<template>
  <div :class="['hr-title', { fr: storeName.FR, ee: storeName.EE }]">
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "hr-title",
  props: {},
  computed: {
    ...mapState("storeInfo", ["storeName"]),
  },
};
</script>

<style lang="less" scoped>
.hr-title {
  .flex-wrap;
  .mx(auto);
  // fr========================
  &.fr {
    h3 {
      .t-t(uppercase);
      .fw(400);
      > span.primary-color {
        .ml;
        color: @primaryColor;
      }
      @media (min-width: 576px) {
        .fz(1.4rem);
        .my(3rem);
        .mx(2em);
      }
      @media (max-width: 576px) {
        .fz(1.1rem);
        .my(2rem);
        .mx(1em);
      }
    }
    &::after,
    &::before {
      content: "";
      display: block;
      .wh(12.5%, auto);
      .border-B;
    }
  }
  // fr========================
  &.ee {
    flex-direction: column;
    &:not(:first-child) {
      .mt(2.5rem);
    }
    .mb(2.5rem);
    h3 {
      .ff(@ee-ff);
      &:after {
        content: "";
        display: block;
        width: 80%;
        .mx(auto);
        .mt;
        .border-B(@primaryColor, 3px);
      }
    }
    p {
      color: @regularText;
      .fz(1rem);
      .fw(500);
      .mt;
    }
    span {
      .t-t;
      .fw(400);
      .fz(2rem);
      &.p-t-c {
        .ml(0.2em);
      }
    }
  }
}
</style>
